<svg class="word-cloud__svg" [attr.viewBox]="viewBox" aria-hidden="true">
  <text
    *ngFor="let box of boxes; trackBy: trackById"
    class="word-cloud__word"
    text-anchor="middle"
    dominant-baseline="central"
    [style.transform]="wordTransform(box)"
    [style.font-size.px]="box.fontSize"
    [style.font-weight]="wordWeight(box)"
    [style.fill]="wordFill(box)"
  >
    {{ box.text }}
  </text>
</svg>

<ul class="sr-only">
  <li *ngFor="let item of prepared; trackBy: trackById">{{ item.text }}: {{ item.weight }}</li>
</ul>
